module.exports = __webpack_public_path__ + "img/beijing18.82939919.jpg";